export const phantomSvg = (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_8225_3072"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="40"
      height="40"
    >
      <path d="M40 6.10352e-05H0V40.0001H40V6.10352e-05Z" fill="white" />
    </mask>
    <g mask="url(#mask0_8225_3072)">
      <path d="M40 6.10352e-05H0V40.0001H40V6.10352e-05Z" fill="#AB9FF2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4074 25.4938C15.8368 27.9004 13.205 30.946 9.70308 30.946C8.04761 30.946 6.45581 30.2645 6.45581 27.3041C6.45581 19.7648 16.7494 8.09381 26.3002 8.09381C31.7335 8.09381 33.8984 11.8635 33.8984 16.1442C33.8984 21.639 30.3327 27.9217 26.7883 27.9217C25.6635 27.9217 25.1116 27.3041 25.1116 26.3244C25.1116 26.0689 25.1541 25.792 25.239 25.4938C24.0292 27.5597 21.6946 29.4765 19.5085 29.4765C17.9167 29.4765 17.1102 28.4755 17.1102 27.0698C17.1102 26.5587 17.2163 26.0263 17.4074 25.4938ZM25.6346 15.9956C25.6346 17.243 24.8986 17.8667 24.0754 17.8667C23.2396 17.8667 22.5161 17.243 22.5161 15.9956C22.5161 14.7483 23.2396 14.1246 24.0754 14.1246C24.8986 14.1246 25.6346 14.7483 25.6346 15.9956ZM30.3123 15.9957C30.3123 17.243 29.5764 17.8667 28.7531 17.8667C27.9173 17.8667 27.1939 17.243 27.1939 15.9957C27.1939 14.7483 27.9173 14.1246 28.7531 14.1246C29.5764 14.1246 30.3123 14.7483 30.3123 15.9957Z"
        fill="#FFFDF8"
      />
    </g>
  </svg>
)
